<div class="dialog-container flexColumnParent">
  <!-- Header -->
  <div class="dialog-header flexItem">
    <h2 class="dialog-title">{{ title }}</h2>
    @if (severity) {
    <div class="severity-circle">
      <svg viewBox="0 0 110 110" class="circular-progress">
        <circle
          cx="55"
          cy="55"
          r="42"
          fill="none"
          stroke="#f7edf5"
          stroke-width="13"
          class="progress-bg"
        />
        <circle
          cx="55"
          cy="55"
          r="42"
          fill="none"
          [style.stroke]="getSeverityColor(severity)"
          stroke-width="13"
          stroke-linecap="round"
          class="progress-bar"
          [style.stroke-dasharray]="263.89"
          [style.stroke-dashoffset]="getSeverityDashOffset(severity)"
        />
      </svg>
      <div class="severity-text">
        {{ getSeverityDisplayText(severity) }}
      </div>
    </div>
    }
    <button class="close-button" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Content -->
  <div class="dialog-content flexItem">
    <ng-content></ng-content>
  </div>
</div>
